import { connect } from 'react-redux';
import {
    formBuilderLoad,
    formBuilderUnload,
    formUpdateSections,
    formUpdateEntries,
    formUpdateMultipleEntries,
    formUpdateName,
    formChangeSection,
    formReorderSections,
    formSetEntries,
    dialogChangeParentMapping,
    dialogLoadMappingsUsed,
    formUpdateFieldIndex,
    formUpdated,
} from '../actions';
import FormBuilder from './FormBuilder';
import isEqual from 'lodash/isEqual';

const mapStateToProps = ({ formBuilder, site }) => {
    const unsavedForm = !isEqual(formBuilder.form, formBuilder.lastSavedForm);
    return {
        form: formBuilder.form,
        currentSection: formBuilder.activeSection,
        multipleFieldIndex: formBuilder.multipleFieldIndex,
        unsavedChanges: unsavedForm,
        currentFieldIndex: formBuilder.currentFieldIndex,
        featureFlags: site.features,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onLoad: (id) => {
        dispatch(formBuilderLoad(id));
    },
    onUnload: () => {
        dispatch(formBuilderUnload());
    },
    onNameChange: (name) => {
        dispatch(formUpdateName(name));
    },
    onSectionsChange: (action, index, name) => {
        dispatch(formUpdateSections({ action, index, name }));
    },
    updateSectionName: (name) => {
        dispatch(formUpdateSections({ name }))
    },
    onStepChange: (step) => {
        dispatch(formChangeSection({ activeSection: step }));
    },
    onSectionsReorder: (sections) => {
        dispatch(formReorderSections(sections));
    },
    onEntriesChange: (entry, index, referenceIndexes) => {
        dispatch(formUpdateEntries({ entry, index, referenceIndexes }));
    },
    onMultipleEntriesChange: (fields, searchForm, fieldIndex) => {
        dispatch(formUpdateMultipleEntries({ fields, searchForm, fieldIndex }));
    },
    setEntries: (entries) => {
        dispatch(formSetEntries(entries));
    },
    onParentMappingChange: (parentMapping) => {
        dispatch(dialogChangeParentMapping(parentMapping));
    },
    loadMappingsUsed: (fields) => {
        dispatch(dialogLoadMappingsUsed(fields));
    },
    updateFieldIndex: (payload) => {
        dispatch(formUpdateFieldIndex(payload));
    },
    onFormImport: (payload) => {
        dispatch(formUpdateSections(payload));
    },
    onFormUpdated: (form) => {
        dispatch(formUpdated(form));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(FormBuilder);
